import { gql } from '@apollo/client';
import { BANNER_BASIC_FRAGMENT } from '../../fragments/bannerFragments';

export const BANNER_LIST_QUERY = gql`
  query BannerList($first: Int, $after: String, $filter: BannerFilterInput) {
    banners(first: $first, after: $after, filter: $filter) {
      edges {
        node {
          ...BannerBasic
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
  ${BANNER_BASIC_FRAGMENT}
`;
